import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { restaurant } from "../mock";

/**
 * Impressum text. Edit the lines in IMPRESSUM below.
 * The page is at /impressum. The footer link "Impressum" opens it.
 */
const IMPRESSUM = {
  company: "Corte Camatti GbR",
  owners: "Luca D’Alconzo, Roberto Lisignoli",
  taxNumber: "143/509/80742",
  vatId: "DE 279781118",
};

export default function ImpressumPage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Impressum – Quattro Tavoli";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-[#FAF4EA] min-h-screen">
      <Navbar solid />

      <article className="max-w-3xl mx-auto px-6 pt-36 pb-24">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 text-[#6b6058] hover:text-[#9C3B2E] transition-colors mb-10"
        >
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </button>

        <h1 className="font-display text-4xl sm:text-5xl font-700 text-[#2A2420]">
          Impressum
        </h1>
        <p className="mt-3 text-sm text-[#9c9188]">
          Angaben gemäß § 5 TMG
        </p>

        <div className="mt-12 space-y-10 text-[#4A423B] font-body leading-relaxed">
          <section>
            <h2 className="font-display text-xl font-600 text-[#2A2420] mb-3">
              Diensteanbieter
            </h2>
            <p>
              {IMPRESSUM.company}
              <br />
              Quattro Tavoli
              <br />
              {restaurant.address}
              <br />
              Deutschland
            </p>
            <p className="mt-4">Inhaber: {IMPRESSUM.owners}</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-600 text-[#2A2420] mb-3">
              Kontakt
            </h2>
            <p>
              Telefon: {restaurant.phone}
              <br />
              E-Mail:{" "}
              <a
                href={`mailto:${restaurant.email}`}
                className="text-[#9C3B2E] hover:underline"
              >
                {restaurant.email}
              </a>
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-600 text-[#2A2420] mb-3">
              Steuernummer &amp; Umsatzsteuer-ID
            </h2>
            <p>
              Steuernummer: {IMPRESSUM.taxNumber}
              <br />
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:{" "}
              {IMPRESSUM.vatId}
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-600 text-[#2A2420] mb-3">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p>
              {IMPRESSUM.owners}
              <br />
              {restaurant.address}
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-600 text-[#2A2420] mb-3">
              Streitschlichtung
            </h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9C3B2E] hover:underline break-all"
              >
                https://ec.europa.eu/consumers/odr
              </a>
              .
            </p>
            <p className="mt-3">
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-600 text-[#2A2420] mb-3">
              Haftung für Inhalte
            </h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
              gespeicherte fremde Informationen zu überwachen oder nach
              Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
              hinweisen.
            </p>
            <p className="mt-3">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
              Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
              wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-600 text-[#2A2420] mb-3">
              Haftung für Links
            </h2>
            <p>
              Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-600 text-[#2A2420] mb-3">
              Urheberrecht
            </h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>
        </div>
      </article>

      <Footer />
    </main>
  );
}
